<template>
  <li>
    <img :src="getCategoryImagePath(item.images, 'COLOR')" alt="">
    <a @click="changeCategory">{{item.name}}</a>
  </li>
</template>

<script>
import { getCategoryImagePath } from 'helpers/images'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { getBaseUrls } from '../helpers/baseURLhelper'
export default {
  name: 'FavoritesList',
  props: {
    item: Object,
    isRadioStation: Boolean
  },
  computed: {
    imgPath () {
      return getBaseUrls('baseImages') + this.item.images[0].path
    },
    ...mapGetters([
      'favoriteChannelsTv'
    ])
  },
  methods: {
    ...mapMutations([
      'UPDATE_SELECTED_TV_CATEGORY',
      'UPDATE_SELECTED_RADIO_CATEGORY',
      'TOGGLE_FAVORITE_SIDEBAR'
    ]),
    ...mapActions([
      'selectChannel'
    ]),
    getCategoryImagePath: function (images, mode) {
      return getCategoryImagePath(images, mode)
    },
    changeCategory: function () {
      if (this.isRadioStation) {
        this.changeRadioCategory()
      } else {
        this.changeTvCategory()
        // this.getEpg()
      }
      this.TOGGLE_FAVORITE_SIDEBAR()
      this.selectChannel(this.favoriteChannelsTv[0])
    },
    changeTvCategory: function () {
      this.UPDATE_SELECTED_TV_CATEGORY(this.item)
      // this.selectChannel()
    },
    changeRadioCategory: function () {
      this.UPDATE_SELECTED_RADIO_CATEGORY(this.item)
    }
  }
}
</script>

<style scoped lang="scss">
@import 'uc/_variables';

li {
    background-color: #202020;
    border-bottom: 1px solid #4d4d4d;
    position: relative;
    text-size-adjust: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

a {
    display: block;
    text-transform: uppercase;
    font-size: 13px;
    padding: 17px 90px 17px 60px;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    position: relative;
    transition: color 200ms ease;

    &:hover {
        color: #0095da;
    }
}

img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    margin-left: 15px;
    max-width: 30px;
    max-height: 30px;
}

@media only screen and (min-width: $breakpoint3) {
    img {
        margin-left: 20px;
        max-width: 35px;
        max-height: 40px;
    }

    a {
        padding: 22px 124px 22px 70px;
        text-transform: uppercase;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FavoritesList.vue